'use client'
import {
  PaymentMethods_default
} from "./chunk-HRESN6R2.mjs";
import {
  PaymentConfig
} from "./chunk-UGUU5QSU.mjs";
import {
  useRedeem
} from "./chunk-7OO2W25G.mjs";
import {
  usePayment
} from "./chunk-QH2UTQBS.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/booking/paymentMethod/PaymentMethodSelector.tsx
import { useEffect as useEffect3, useMemo as useMemo2 } from "react";
import { RadioGroup, Typography as Typography9 } from "@wbk/ui";
import { useTranslation as useTranslation9 } from "@wbk/config";

// src/components/booking/paymentMethod/CreditCard.tsx
import { CreditCardIcon } from "@wbk/svg";
import { useTranslation as useTranslation3 } from "@wbk/config";
import { Collapsible, Divider, Typography as Typography3 } from "@wbk/ui";

// src/components/booking/paymentMethod/PaytabsForm.tsx
import { useEffect, useRef } from "react";
import { useTranslation } from "@wbk/config";
import { Input, Typography } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { loadScriptAsync } from "@wbk/utils";
import { jsx, jsxs } from "react/jsx-runtime";
var PaytabsForm = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { inlinePaytabs, paytabs } = usePayment();
  const { t } = useTranslation("payment_common");
  const formRef = useRef(null);
  useEffect(() => {
    if (!inlinePaytabs)
      return;
    loadScriptAsync({
      id: "paytabs-paylib",
      url: "https://secure.paytabs.sa/payment/js/paylib.js"
    }).then(() => {
      var _a2;
      if (!window.paylib)
        return;
      window.paylib.inlineForm({
        key: ((_a2 = PaymentConfig.config) == null ? void 0 : _a2.paytabsClientKey) || "",
        form: formRef.current,
        autoSubmit: false,
        beforeSubmit: function() {
          if (paytabs == null ? void 0 : paytabs.onBeforeSubmit) {
            return paytabs == null ? void 0 : paytabs.onBeforeSubmit();
          }
          return true;
        },
        callback: function(response) {
          var _a3, _b2;
          if (response.error) {
            (_a3 = window.paylib) == null ? void 0 : _a3.handleError(document.getElementById("paymentErrors"), response);
          } else {
            (_b2 = paytabs == null ? void 0 : paytabs.onCallback) == null ? void 0 : _b2.call(paytabs, response);
          }
        }
      });
    });
  }, [inlinePaytabs, paytabs]);
  if (!inlinePaytabs)
    return null;
  return /* @__PURE__ */ jsxs("form", __spreadProps(__spreadValues({}, props), { id: "paytabs-form", ref: formRef, className: twMerge("space-y-4", className), children: [
    /* @__PURE__ */ jsx(
      Input,
      {
        label: t("payment_common:card_number"),
        maxLength: 20,
        "data-paylib": "number",
        placeholder: "1234 1234 1234 1234",
        inputMode: "numeric"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "label-M", className: "mb-1", children: t("payment_common:exp_date") }),
        /* @__PURE__ */ jsxs("div", { className: "border-paper rounded-S flex grow items-center overflow-hidden border", children: [
          /* @__PURE__ */ jsx(
            Input,
            {
              maxLength: 2,
              "data-paylib": "expmonth",
              className: "w-10 border-none !pe-0",
              placeholder: "MM",
              inputMode: "numeric",
              rounded: false
            }
          ),
          /* @__PURE__ */ jsx(Typography, { as: "span", color: "text-secondary", children: "/" }),
          /* @__PURE__ */ jsx(
            Input,
            {
              maxLength: 2,
              "data-paylib": "expyear",
              className: "border-none px-2",
              placeholder: "YY",
              inputMode: "numeric",
              rounded: false
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx(
        Input,
        {
          label: t("payment_common:cvv"),
          maxLength: 4,
          "data-paylib": "cvv",
          groupClassName: "w-full",
          className: "grow",
          placeholder: "CVV",
          inputMode: "numeric"
        }
      )
    ] }),
    /* @__PURE__ */ jsx(Input, { type: "hidden", "data-paylib": "savedcard", className: "grow" }),
    /* @__PURE__ */ jsx(Typography, { variant: "body-S", color: "error", id: "paymentErrors" })
  ] }));
};
var PaytabsForm_default = PaytabsForm;

// src/components/booking/paymentMethod/CardType.tsx
import { useMemo } from "react";
import { ToggleGroup, Typography as Typography2 } from "@wbk/ui";
import { useTranslation as useTranslation2 } from "@wbk/config";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var CardTypeSelector = () => {
  const { t } = useTranslation2("payment_common");
  const { event, cardType, setCardType, isValid } = usePayment();
  const options = useMemo(() => {
    var _a, _b, _c;
    const list = [];
    list.push({
      text: /* @__PURE__ */ jsx2("div", { className: "flex gap-1", children: /* @__PURE__ */ jsx2(PaymentMethods_default, { supported: ["visa", "master_card"], className: "h-6 w-10", logosOnly: true }) }),
      value: "visa"
    });
    const defaultEmpty = !((_a = event.card_types) == null ? void 0 : _a.length);
    const hasMada = defaultEmpty || ((_b = event.card_types) == null ? void 0 : _b.some((r) => r.code === "mada"));
    const hasAmex = defaultEmpty || ((_c = event.card_types) == null ? void 0 : _c.some((r) => r.code === "american_express"));
    if (hasMada) {
      list.push({
        text: /* @__PURE__ */ jsx2("div", { className: "flex gap-1", children: /* @__PURE__ */ jsx2(PaymentMethods_default, { supported: ["mada"], className: "h-6 w-10", logosOnly: true }) }),
        value: "mada"
      });
    }
    if (hasAmex) {
      list.push({
        text: /* @__PURE__ */ jsx2("div", { className: "flex gap-1", children: /* @__PURE__ */ jsx2(PaymentMethods_default, { supported: ["american_express"], className: "h-6 w-10", logosOnly: true }) }),
        value: "amex"
      });
    }
    return list;
  }, [event.card_types]);
  return /* @__PURE__ */ jsxs2("div", { className: "py-S space-y-S", children: [
    /* @__PURE__ */ jsx2(Typography2, { color: !isValid ? "error" : "text-primary", children: t("payment_common:choose_card_type") }),
    /* @__PURE__ */ jsx2(
      ToggleGroup,
      {
        type: "single",
        className: "border-paper data-[state=on]:bg-action/10 data-[state=on]:border-action border-2 py-1",
        value: cardType || "",
        options,
        onChange: (value) => {
          setCardType(value);
        },
        phill: true
      }
    )
  ] });
};
var CardType_default = CardTypeSelector;

// src/components/booking/paymentMethod/CreditCard.tsx
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var CreditCard = ({ disabled }) => {
  var _a, _b;
  const { paymentMethod, event, inlinePaytabs, currency } = usePayment();
  const { t } = useTranslation3("payment_common");
  const selected = paymentMethod === "credit_card" || paymentMethod === "managed_form";
  const open = selected && inlinePaytabs && !disabled;
  const isBHD = currency === "BHD";
  const openBhd = selected && isBHD && !disabled;
  return /* @__PURE__ */ jsxs3(
    Collapsible,
    {
      open: open || openBhd,
      trigger: /* @__PURE__ */ jsxs3("div", { className: "flex min-h-10 grow items-center gap-3", children: [
        /* @__PURE__ */ jsx3(CreditCardIcon, { className: "h-6 w-6 shrink-0" }),
        /* @__PURE__ */ jsxs3("div", { children: [
          /* @__PURE__ */ jsx3(Typography3, { variant: "label-M", children: t("payment_common:credit_card_payment") }),
          /* @__PURE__ */ jsx3("div", { className: "flex gap-2", children: /* @__PURE__ */ jsx3(
            PaymentMethods_default,
            {
              supported: ((_a = event.card_types) == null ? void 0 : _a.length) ? event.card_types.map((t2) => t2.code) : void 0,
              className: "h-5 w-6",
              logosOnly: true
            }
          ) })
        ] })
      ] }),
      children: [
        isBHD ? /* @__PURE__ */ jsx3(CardType_default, {}) : /* @__PURE__ */ jsxs3(Fragment, { children: [
          /* @__PURE__ */ jsx3(Divider, { className: "my-3" }),
          /* @__PURE__ */ jsx3(PaytabsForm_default, {})
        ] }),
        (event == null ? void 0 : event.card_discounts) && event.card_discounts.length > 0 && /* @__PURE__ */ jsxs3("div", { className: "space-y-3", children: [
          /* @__PURE__ */ jsx3(Divider, {}),
          /* @__PURE__ */ jsx3("ul", { className: "list-disc space-y-2 ltr:ml-4 rtl:mr-4", children: (_b = event == null ? void 0 : event.card_discounts) == null ? void 0 : _b.map((discount) => {
            return /* @__PURE__ */ jsx3("li", { className: "text-text/60 text-sm", children: discount.title }, discount._id);
          }) })
        ] })
      ]
    }
  );
};
var CreditCard_default = CreditCard;

// src/components/booking/paymentMethod/Tabby.tsx
import { useEffect as useEffect2 } from "react";
import { Modal, Typography as Typography4 } from "@wbk/ui";
import { TabbyIcon } from "@wbk/svg";
import { CurrencyPriceLabel } from "@wbk/currency";
import { Trans, useRouter, useTranslation as useTranslation4 } from "@wbk/config";
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var Tabby = ({ totals }) => {
  const { paymentMethod, setPaymentMethod, isTabbyEnabled, currency, event, inlinePaytabs } = usePayment();
  const { locale } = useRouter();
  const { t } = useTranslation4("payment_common");
  const minAmount = Number(event == null ? void 0 : event.tabby_min_order_limit);
  const isBelowMinimum = minAmount && totals.net_after_discount < minAmount;
  const canPayTabby = isTabbyEnabled && !isBelowMinimum;
  useEffect2(() => {
    if (paymentMethod === "tabby" && !canPayTabby) {
      setPaymentMethod(inlinePaytabs ? "managed_form" : "credit_card");
    }
  }, [paymentMethod, canPayTabby, setPaymentMethod, inlinePaytabs]);
  return /* @__PURE__ */ jsx4(
    Modal,
    {
      size: "2xl",
      className: "bg-transparent p-4",
      closeButton: true,
      zIndex: 9999,
      render: ({ open }) => /* @__PURE__ */ jsxs4("div", { className: "flex min-h-10 items-center gap-3", children: [
        /* @__PURE__ */ jsx4("div", { className: "flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-white p-0.5 text-black", children: /* @__PURE__ */ jsx4(TabbyIcon, {}) }),
        /* @__PURE__ */ jsxs4("div", { className: "grow", children: [
          /* @__PURE__ */ jsx4(Typography4, { as: "div", variant: "body-S", children: t("payment_common:pay_with_tabby") }),
          /* @__PURE__ */ jsx4(Typography4, { as: "div", variant: "body-S", children: isBelowMinimum ? /* @__PURE__ */ jsxs4("span", { children: [
            t("payment_common:tabby_minimum_amount"),
            /* @__PURE__ */ jsx4(
              CurrencyPriceLabel,
              {
                className: "inline-block ps-1 font-bold [&_svg]:h-3 [&_svg]:w-3",
                priceClassName: "text-body-S font-bold",
                originalPrice: minAmount,
                currency
              }
            )
          ] }) : /* @__PURE__ */ jsx4(Fragment2, { children: /* @__PURE__ */ jsxs4(Trans, { i18nKey: "tabby_payment_with_price_formal", ns: "payment_common", children: [
            /* @__PURE__ */ jsx4(
              CurrencyPriceLabel,
              {
                originalPrice: totals.net_after_discount / 4,
                currency,
                className: "inline-block font-bold [&_svg]:h-3 [&_svg]:w-3",
                priceClassName: "text-body-S font-bold"
              }
            ),
            /* @__PURE__ */ jsx4(
              "button",
              {
                className: "text-sky-500 underline hover:text-sky-400 disabled:cursor-not-allowed",
                onClick: open,
                disabled: !canPayTabby
              }
            )
          ] }) }) })
        ] })
      ] }),
      body: () => /* @__PURE__ */ jsx4(
        "iframe",
        {
          title: "Tabby Payment Installments",
          className: "mini-scrollbar h-screen max-h-full w-full overflow-y-auto rounded-lg",
          src: canPayTabby ? `//checkout.tabby.ai/promos/product-page/installments/${locale}/?currency=SAR&price=${totals.net_after_discount}` : `//checkout.tabby.ai/promos/product-page/installments/${locale}/?installmentsCount=0`
        }
      )
    }
  );
};
var Tabby_default = Tabby;

// src/components/booking/paymentMethod/ApplePay.tsx
import { useTranslation as useTranslation5 } from "@wbk/config";
import { ApplePayIcon } from "@wbk/svg";
import { Typography as Typography5 } from "@wbk/ui";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var ApplePay = () => {
  const { currency } = usePayment();
  const { t } = useTranslation5("payment_common");
  return /* @__PURE__ */ jsxs5("div", { className: "flex min-h-10 items-center gap-3", children: [
    /* @__PURE__ */ jsx5("div", { className: "flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-white p-0.5 text-black", children: /* @__PURE__ */ jsx5(ApplePayIcon, {}) }),
    /* @__PURE__ */ jsxs5("div", { className: "grow", children: [
      /* @__PURE__ */ jsxs5(Typography5, { variant: "label-M", children: [
        t("payment_common:apple_pay"),
        currency === "BHD" ? ` - ${t("payment_common:visa_master")}` : null
      ] }),
      currency === "BHD" && /* @__PURE__ */ jsx5("div", { className: "flex gap-2", children: /* @__PURE__ */ jsx5(PaymentMethods_default, { supported: ["visa", "master_card"], className: "h-5 w-6", logosOnly: true }) })
    ] })
  ] });
};
var ApplePay_default = ApplePay;

// src/components/booking/paymentMethod/BenefitPay.tsx
import { useTranslation as useTranslation6 } from "@wbk/config";
import { Typography as Typography6 } from "@wbk/ui";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var BenefitPay = () => {
  const { t } = useTranslation6("payment_common");
  return /* @__PURE__ */ jsxs6("div", { className: "flex min-h-10 items-center gap-3", children: [
    /* @__PURE__ */ jsx6("div", { className: "h-6 w-6 shrink-0", children: /* @__PURE__ */ jsx6("img", { src: "/@wbk/payment/benefit_pay.png", alt: t("payment_common:benefit") }) }),
    /* @__PURE__ */ jsxs6("div", { className: "grow", children: [
      /* @__PURE__ */ jsx6(Typography6, { variant: "label-M", children: t("payment_common:benefit") }),
      /* @__PURE__ */ jsx6(Typography6, { variant: "body-S", color: "text-secondary", children: t("payment_common:benefit_desc") })
    ] })
  ] });
};
var BenefitPay_default = BenefitPay;

// src/components/booking/paymentMethod/StcPay.tsx
import { useTranslation as useTranslation7 } from "@wbk/config";
import { StcPayIcon } from "@wbk/svg";
import { Typography as Typography7 } from "@wbk/ui";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var StcPay = () => {
  const { t } = useTranslation7("payment_common");
  return /* @__PURE__ */ jsxs7("div", { className: "flex min-h-10 items-center gap-3", children: [
    /* @__PURE__ */ jsx7("div", { className: "flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-white p-0.5", children: /* @__PURE__ */ jsx7(StcPayIcon, {}) }),
    /* @__PURE__ */ jsx7("div", { className: "grow", children: /* @__PURE__ */ jsx7(Typography7, { variant: "label-M", children: t("payment_common:stc_pay") }) })
  ] });
};
var StcPay_default = StcPay;

// src/components/booking/paymentMethod/ApplePayMada.tsx
import { useTranslation as useTranslation8 } from "@wbk/config";
import { ApplePayIcon as ApplePayIcon2 } from "@wbk/svg";
import { Typography as Typography8 } from "@wbk/ui";
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var ApplePayMada = () => {
  const { currency } = usePayment();
  const { t } = useTranslation8("payment_common");
  return /* @__PURE__ */ jsxs8("div", { className: "flex min-h-10 items-center gap-3", children: [
    /* @__PURE__ */ jsx8("div", { className: "flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-white p-0.5 text-black", children: /* @__PURE__ */ jsx8(ApplePayIcon2, {}) }),
    /* @__PURE__ */ jsxs8("div", { className: "grow", children: [
      /* @__PURE__ */ jsxs8(Typography8, { variant: "label-M", children: [
        t("payment_common:apple_pay"),
        currency === "BHD" ? ` - ${t("payment_common:mada_amex")}` : null
      ] }),
      /* @__PURE__ */ jsx8("div", { className: "flex gap-2", children: /* @__PURE__ */ jsx8(PaymentMethods_default, { supported: ["mada", "american_express"], className: "h-5 w-6", logosOnly: true }) })
    ] })
  ] });
};
var ApplePayMada_default = ApplePayMada;

// src/components/booking/paymentMethod/PaymentMethodSelector.tsx
import { jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var PaymentMethodSelector = (_a) => {
  var _b = _a, {
    className,
    totals,
    tabby = true,
    applePay = true,
    error
  } = _b, props = __objRest(_b, [
    "className",
    "totals",
    "tabby",
    "applePay",
    "error"
  ]);
  const {
    paymentMethod,
    setPaymentMethod,
    canUseApplePay,
    isTabbyEnabled,
    isBenefitPayEnabled,
    isStcPayEnabled,
    event,
    inlinePaytabs,
    currency,
    setCardType,
    cardType
  } = usePayment();
  const { t } = useTranslation9("payment_common");
  const { enable_wallet_credits } = useRedeem();
  const paymentDisabled = enable_wallet_credits && totals.net_after_discount <= 0;
  const method = paymentMethod === "apple_pay" && cardType === "mada" ? "apple_pay_mada" : paymentMethod;
  useEffect3(() => {
    const rest = paymentMethod === "tabby" && !tabby || paymentMethod === "apple_pay" && !applePay;
    if (rest) {
      setPaymentMethod(inlinePaytabs ? "managed_form" : "credit_card");
    }
  }, [applePay, inlinePaytabs, paymentMethod, setPaymentMethod, tabby]);
  const paymentOptions = useMemo2(() => {
    const withApplePay = canUseApplePay && applePay;
    const options = [];
    if (isBenefitPayEnabled) {
      options.push({ text: /* @__PURE__ */ jsx9(BenefitPay_default, {}), value: "benefit" });
    }
    if (withApplePay) {
      options.push({ text: /* @__PURE__ */ jsx9(ApplePay_default, {}), value: "apple_pay" });
    }
    if (withApplePay && currency === "BHD") {
      options.push({ text: /* @__PURE__ */ jsx9(ApplePayMada_default, {}), value: "apple_pay_mada" });
    }
    options.push({
      text: /* @__PURE__ */ jsx9(CreditCard_default, { disabled: paymentDisabled }),
      value: inlinePaytabs ? "managed_form" : "credit_card"
    });
    if (isTabbyEnabled && tabby) {
      const minAmount = Number(event == null ? void 0 : event.tabby_min_order_limit);
      const canPayTabby = minAmount && totals.net_after_discount >= minAmount;
      options.push({
        text: /* @__PURE__ */ jsx9(Tabby_default, { totals }),
        value: "tabby",
        disabled: !canPayTabby
      });
    }
    if (isStcPayEnabled) {
      options.push({ text: /* @__PURE__ */ jsx9(StcPay_default, {}), value: "stc" });
    }
    return options;
  }, [
    canUseApplePay,
    applePay,
    paymentDisabled,
    inlinePaytabs,
    isBenefitPayEnabled,
    isTabbyEnabled,
    tabby,
    isStcPayEnabled,
    currency,
    event == null ? void 0 : event.tabby_min_order_limit,
    totals
  ]);
  return /* @__PURE__ */ jsx9("div", { className, children: /* @__PURE__ */ jsx9("div", { className: "max-w-lg", children: /* @__PURE__ */ jsxs9("fieldset", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx9("legend", { children: /* @__PURE__ */ jsx9(Typography9, { variant: "heading-M", children: t("payment_common:select_payment_method") }) }),
    /* @__PURE__ */ jsx9(
      RadioGroup,
      __spreadValues({
        name: "payment-method-selector",
        label: "",
        theme: "action",
        indicator: "check",
        value: paymentDisabled ? "" : method,
        className: "items-start py-3 [&>button]:mt-2",
        disabled: paymentDisabled,
        options: paymentOptions.map((option) => ({
          text: option.text,
          value: option.value,
          disabled: option.disabled
        })),
        onChange: (option) => {
          const same = option === method;
          if (same) {
            return;
          }
          setCardType((option == null ? void 0 : option.includes("_mada")) ? "mada" : void 0);
          if (option == null ? void 0 : option.includes("apple_pay")) {
            return setPaymentMethod("apple_pay");
          }
          setPaymentMethod(option);
        },
        error
      }, props)
    )
  ] }) }) });
};
var PaymentMethodSelector_default = PaymentMethodSelector;

export {
  PaytabsForm_default,
  PaymentMethodSelector_default
};
//# sourceMappingURL=chunk-V43DO47K.mjs.map